























































//import {auth, authObject} from "@/scripts/firebase";
import { NoticeProps } from "@/scripts/datatypes";
import { Component,Mixins} from "vue-property-decorator";
import Notice from "@/components/Notice.vue";
import { ValidationObserver } from 'vee-validate'
import Common from '@/mixins/common'

@Component({
  components: {
    Notice
  }
})

export default class ChangePassword extends Mixins(Common) {
  password = ''
  email = ''
  isLoading =  false
  notice: NoticeProps = {}

  get emailNow(){
    return this.$store.state.user.email
  }

  get observer(){
    return this.$refs.changeEmailValidationObserver as InstanceType<typeof ValidationObserver>
  }
  
  mounted(){
    console.log('mounted');
  }

  async created() {
    console.trace('created')
  }

  async changeEmail() {
     try{
      this.notice = {
				isShow: false,
      }
			
			if(await this.observer.validate()){
        this.$store.commit("setLoading",true);
        this.isLoading = true
        const user = await this.$reauthenticateWithEmail(this.emailNow,this.password);
        
        await user.verifyBeforeUpdateEmail(this.email)
       
        this.notice = {
          message: this.$t('changeEmail.success') as string,
          isShow: true,
          duration: 0,
          type: {'is-success': true}
        }

        this.password = ''
        this.email = ''
        this.observer.reset()
      }
      
    }catch(error) {
      console.table(error)
      const errorCode = this.$getErrorCode(error)
      console.log(errorCode)

      const errorMessage0 = this.$t('changeEmail.error') as string
      const errorMessage1 = this.$getErrorMessage(errorCode)
      const errorField = this.$getErrorField(errorCode)

      if(errorMessage1 && errorField){
        this.observer.setErrors({
         [errorField]: errorMessage1
        })
      }

			const errorMessage = (errorMessage1 === '') ? errorMessage0 : errorMessage0 + '<br />' + errorMessage1
			this.notice = {
				message: errorMessage,
				isShow: true,
				type: {'is-danger': true}
      }
    }finally{
      this.isLoading = false
      this.$store.commit("setLoading",false);
    }
  }
}
